import AppLayout from "../../layouts/AppLayout";
import AccountInfo from "../../components/Profile/AccountInfo";

const Profile = () => {
    return (
        <AppLayout>
            <div className="mx-[46px] mb-[36px]">
                <div className="w-full">
                    <div className="flex md:flex-row flex-col w-full gap-[29px] items-stretch">
                        <AccountInfo></AccountInfo>
                    </div>
                </div>
            </div>
        </AppLayout>
    );
};
export default Profile;
